'use client';

import React from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';
import { ContentLayout } from '@/features/client/Services/components/ContentLayout/ContentLayout';
import { RequestForm } from '@/features/client/Forms/RequestForm/RequestForm';
import { ServicesNavMenu } from '@/features/client/Services/components/ServicesNavMenu/ServicesNavMenu';
import image from '@/public/images/services/main_page/air_conditiong.webp';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContentV2 } from '@/features/client/Services/components/Content/ContentV2';
const data = {
  title: 'Ductless Cooling & Heating Services',
  description:
    'Our skilled team ensures your home or business benefits from precise temperature control. Experience the comfort of a perfectly adjusted environment without the hassle of traditional duct systems. Looking for general <a href="https://tytum.com/services/heating-and-air">heating and air repair in San Diego</a>? We’ve got you covered with expert ductless solutions tailored to your needs.',
  image: image,
  offer_title: '',
  offer_data: [
    {
      title: 'Repair:',
      list: [
        {
          title: 'Insufficient Heating or Cooling:',
          description: `Your ductless system isn’t providing the comfort you need, leaving you too hot or too cold.`,
        },
        {
          title: 'Inconsistent Temperature:',
          description: `Your ductless system may struggle to maintain a steady temperature, causing discomfort in your space.`,
        },
        {
          title: 'Unusual Noises:',
          description: `Strange or loud noises from the unit could signal mechanical issues that need prompt attention.`,
        },

        {
          title: 'Airflow Issues:',
          description: `Reduced airflow from the unit can impact performance and comfort, signaling potential blockages or faults.`,
        },

        {
          title: 'Poor Air Quality: ',
          description: `Issues with your ductless system can affect the air quality in your space, impacting your comfort and health.`,
        },

        {
          title: 'Wrong Sizing:',
          description: `Installing a ductless system that’s too small or too large for your space can result in inefficiency and discomfort.`,
        },

        {
          title: 'Incorrect Placement:',
          description: ` The positioning of indoor units can greatly impact airflow and comfort, leading to uneven heating or cooling if done improperly.`,
        },

        {
          title: 'Electrical Issues:',
          description: `Faulty wiring during installation may prevent the system from running correctly or pose safety hazards. Our licensed team works closely with trusted <a href="https://tytum.com/services/electrical">electrical services</a> to ensure safe and dependable system operation.`,
        },

        {
          title: 'Refrigerant Line Problems:',
          description: `Poor installation of refrigerant lines can cause leaks or reduced performance from the start.`,
        },
      ],
    },

    {
      title: 'Installation: ',
      description: `Our technicians provide expert <a href="https://tytum.com/services/heating-and-air/ac-installation">air conditioner installation in San Diego</a>, ensuring that every system is set up for maximum efficiency and long-term reliability.`,
      list: [
        { title: ' New ductless mini-split ', description: '' },
        { title: ' Ductless heat pump', description: '' },
        { title: ' Multi-zone ductless system', description: '' },
        { title: ' Single-zone ductless system', description: '' },

        { title: ' Smart thermostat for ductless systems', description: '' },
        { title: ' Zoning system setup for ductless units', description: '' },
        { title: ' Ductless air filtration system', description: '' },
        { title: ' Indoor air handler', description: '' },
        { title: ' Outdoor condenser unit', description: '' },

        {
          title: ' Programmable thermostat for ductless systems',
          description: '',
        },
      ],
    },
    {
      title: 'Replacement: ',
      list: [
        {
          title: 'Old System Inefficiency:',
          description: `Older ductless systems may become less efficient, leading to higher energy bills and reduced comfort. In such cases, we provide expert <a href="https://tytum.com/services/heating-and-air/heating-installation">heater installation in San Diego</a> to restore reliable warmth and efficiency.`,
        },
        {
          title: 'Dirty Filters:',
          description: `Regular maintenance is required to keep filters clean and ensure good airflow and air quality.`,
        },

        {
          title: 'Refrigerant Level Check:',
          description: `Low refrigerant levels can affect cooling performance and efficiency, and should be checked during routine maintenance.`,
        },

        {
          title: 'Outdoor Unit Obstructions:',
          description: `Debris around the outdoor unit can restrict airflow and reduce system efficiency, making regular checks important.`,
        },
      ],
    },
  ],
  banner_title: `“Flexible Comfort Solutions”`,
  banner_description: `Experience the convenience of ductless systems with Tytum. From installation and maintenance to <a href="https://tytum.com/services/heating-and-air/heating">heating service and repair in San Diego</a>, we deliver personalized comfort without the need for extensive ductwork.`,
  why_title: 'What do we offer',
  bookServiceButton: true,
  why_description: `You need someone you can trust, and our approach to client satisfaction is simple: 
we make promises and always keep them.`,
  why_items: [
    {
      title: 'We offer same-day service for your convenience.',
      description: '',
    },
    {
      title:
        'Our certified and experienced technicians ensure top-quality work.',
      description: '',
    },
    {
      title: 'Enjoy affordable pricing with no hidden fees.',
      description: '',
    },
    {
      title: 'We guarantee 100% satisfaction with our services.',
      description: '',
    },
  ],
  why_footerText:
    'Trust us to be your go-to provider in the San Diego area and ensure the comfort and safety of your home. From HVAC to <a href="https://tytum.com/services/plumbing">plumbing services in San Diego</a>, we deliver complete solutions for comfort and efficiency. Call us or fill out our online form for questions or a free quote.',
};

const CoolingHeatingPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="line">
        <MainSection
          label="Service Details"
          title="Ductless Air Conditioning Service & Repair in San Diego"
          description="Stay cool and comfortable with our expert air conditioning services.
From installation to repair and maintenance, we ensure your home stays the perfect temperature all year round."
          withContactButton
        />
      </MainSectionLayout>

      <Section variant="secondary">
        <Container>
          <ContentLayout
            contentLeft={
              <>
                <ServicesNavMenu />
                <RequestForm />
              </>
            }
            contentRight={<ContentV2 data={data} />}
          />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ServiceCardsSection shortVariant={true} />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default CoolingHeatingPage;
